import React from 'react';
import { Input } from 'reactstrap';

const NumberField = ({ field, value, onChange, disabled }) => (
  <Input
    type="number"
    name={field.key}
    placeholder={field.label}
    value={value == null ? '' : value}
    disabled={disabled}
    onChange={(e) => {
      const raw = e.target.value;
      // Keep the field empty-able while editing; coerce to Number when present.
      onChange(field.key, raw === '' ? '' : Number(raw));
    }}
    style={{ maxWidth: '500px' }}
  />
);

export default NumberField;
